/**
 * @enum Suit - type of suit
 */
export enum Suit {
    /**
     * @member clubs
     */
    Clubs = <any>'clubs',

    /**
     * @member diamonds
     */
    Diamonds = <any>'diamonds',

    /**
     * @member hearts
     */
    Hearts = <any>'hearts',

    /**
     * @member spades
     */
    Spades = <any>'spades'
}


/** WEBPACK FOOTER **
 ** ./Engine/Communication/Game/Types/Suit.ts
 **/